import moment from 'moment';
import React, { useCallback, useMemo } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { TYPE_OPTIONS } from '../../../contants/createBudget';
import {
  addFormData,
  setEndDateError,
  setNameError,
  setStartDateError,
  setTypeError,
  setUniqueNameError,
} from '../../../features/createBudget/createBudgetSlice';
import { parceBudget } from '../../../helpers/parceBudget';
import BudgetAmountInput from '../BudgetAmountInput';
import BudgetNameInput from '../BudgetNameInput';
import BudgetTypeSelect from './BudgetTypeSelect';
import DateRange from './DateRange';

const SetCustomBudget = () => {
  const dispatch = useDispatch();
  const {
    formData,
    startDateError,
    endDateError,
    amountError,
    typeError,
    nameError,
    uniqueNameError,
  } = useSelector(state => state.createBudget, shallowEqual);

  const isDateRangeLongEnough = useMemo(() => {
    if (!formData.start_date || !formData.end_date) return true;
    return (
      moment(formData.end_date).diff(moment(formData.start_date), 'days') >= 2
    );
  }, [formData.start_date, formData.end_date]);

  const rangeError =
    !isDateRangeLongEnough && !startDateError && !endDateError
      ? 'Date range must be at least 2 days apart.'
      : '';

  const updateForm = useCallback(
    patch => dispatch(addFormData({ ...formData, ...patch })),
    [dispatch, formData],
  );

  const handleStartDate = useCallback(
    date => {
      dispatch(setStartDateError(false));
      dispatch(setEndDateError(false));
      updateForm({ start_date: date });
    },
    [dispatch, updateForm],
  );

  const handleEndDate = useCallback(
    date => {
      dispatch(setStartDateError(false));
      dispatch(setEndDateError(false));
      updateForm({ end_date: date });
    },
    [dispatch, updateForm],
  );

  const handleAmountChange = useCallback(
    raw => {
      updateForm({ amount: raw });
    },
    [dispatch, updateForm],
  );

  const handleTypeChange = useCallback(
    value => {
      dispatch(setTypeError(false));
      updateForm({ type: value });
    },
    [dispatch, updateForm],
  );

  const handleNameChange = useCallback(
    value => {
      dispatch(setNameError(false));
      dispatch(setUniqueNameError(false));
      updateForm({ name: value });
    },
    [dispatch, updateForm],
  );

  return (
    <>
      <DateRange
        startDate={formData.start_date}
        endDate={formData.end_date}
        onStartDateChange={handleStartDate}
        onEndDateChange={handleEndDate}
        startDateError={startDateError || rangeError}
        endDateError={endDateError || rangeError}
      />

      <BudgetAmountInput
        value={formData.amount}
        error={amountError}
        onChange={handleAmountChange}
        format={parceBudget}
      />

      <BudgetTypeSelect
        value={formData.type}
        error={typeError}
        options={TYPE_OPTIONS}
        onChange={handleTypeChange}
      />

      <BudgetNameInput
        value={formData.name || ''}
        error={nameError || uniqueNameError}
        onChange={handleNameChange}
      />
    </>
  );
};

export default SetCustomBudget;
